import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import enLocales from 'utils/locales/en.json';
import viLocales from 'utils/locales/vi.json';
import koLocales from 'utils/locales/ko.json';

export const resources = {
    en: { translation: enLocales },
    vi: { translation: viLocales },
    ko: { translation: koLocales },
} as const;

declare module 'i18next' {
    interface CustomTypeOptions {
        returnNull: false
    }
}

i18n.use(HttpBackend).use(LanguageDetector).use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        //lng: 'vi', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option
        fallbackLng: 'vi',
        detection: {
            order: ['querystring', 'cookie'],
            caches: ['cookie']
        },
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        returnNull: false,
    });
export default i18n;
